import React, { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import { api_path } from "../shared";
export function AuthenResponseDetail() {
  const [showMsg, setMsg] = useState("");
  const { instance, accounts } = useMsal();
  const [getAccessToken, setAccessToken] = useState(null);
  const [getUserEmail, setUserEmail] = useState("");
  function RequestAccessToken() {
    const request = {
      ...loginRequest,
      account: accounts[0],
    };
    // Silently acquires an access token which is then attached to a request for Microsoft Graph data
    instance
      .acquireTokenSilent(request)
      .then((response) => {
        setAccessToken(response.accessToken);
      })
      .catch((e) => {
        instance.acquireTokenPopup(request).then((response) => {
          setAccessToken(response.accessToken);
        });
      });
  }
  useEffect(() => {
    RequestAccessToken();
    setUserEmail(accounts[0]?.username);
    //console.log("getUserEmail= " + getUserEmail);
    //console.log("getAccessToken= " + getAccessToken);
    var data = {
      USER_EMAIL: getUserEmail,
      USER_TOKEN: getAccessToken,
    };
    fetch(api_path + "/AUTHEN.php", {
      method: "POST",
      headers: {
        Accept: "application/form-data",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((res) => {
        console.log("Message ..." + res["message"])
        if (res["message"] == "REGISTER") {
          window.location = "./Register";
        } else if (res["message"] == "INACTIVE") {
          setMsg("Your active was disabled.");
          window.location = "./Home?status=inactive";
        } else if (res["message"] == "NOROLE") {
          window.location = "./Home?status=norole";
          setMsg("Please wait administrator to assign role.");
        } else if (res["message"] == "HAVEROLE") {
          localStorage.setItem('USER_ID', JSON.stringify(res['USER_ID']));
          localStorage.setItem('USER_EMAIL', JSON.stringify(res['USER_EMAIL']));
          localStorage.setItem('USER_FIRSTNAME', JSON.stringify(res['USER_FIRSTNAME']));
          localStorage.setItem('USER_LASTNAME', JSON.stringify(res['USER_LASTNAME']));
          localStorage.setItem('USER_EMPCODE', JSON.stringify(res['USER_EMPCODE']));
          localStorage.setItem('USER_ROLE_ID', JSON.stringify(res['USER_ROLE_ID']));
          window.location = "./Home?status=haverole";
        }
      });
  });
  return (
    <Container maxWidth="lg" className="center">
      <Grid container alignContent={"center"}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <div className="h4">{showMsg} </div>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}
export default AuthenResponseDetail;
